<app-page headline="Buyer Upload">
  <div stack-layout gap="md">
    <app-card headline="Buyer Data">
      <div ngProjectAs="header-content">
        <app-download-button
          mode="text"
          [blobObservable]="buyerService.downloadBuyersBySelectedRegion()"
          [downloadFileName]="getDownloadFilename()"
        />
      </div>
    </app-card>
    <app-card headline="Upload Buyer File">
      <div ngProjectAs="header-content">
        <app-select
          [options]="entities.businessEntityOptions()"
          [form]="uploadForm"
          controlName="entityCode"
          placeholder="...select a business entity"
        ></app-select>
      </div>
      <oui-file-drop-zone
        #fileDropZone
        [height]="160"
        [allowedFileExtensions]="['xlsx', 'xls']"
        style="width: 100%"
        [helpTemplate]="fileDropZoneContent"
        (fileAttached)="handleFileAttached($event)"
        (fileRemoved)="selectedFile.set(undefined)"
      />
      <ng-template #fileDropZoneContent>
        <div stack-layout [fullWidth]="true" alignItems="center" gap="sm">
          <Text role="title-small" align="center">
            Drag and drop the file here or
            <a
              href="javascript:void(0)"
              (click)="fileDropZone.openFileSelector()"
              >Choose File</a
            >
          </Text>
          <Text role="title-small" align="center" color="on-background-variant">
            Please ensure the uploaded file contains all of the existing fields.
          </Text>
        </div>
      </ng-template>
      <div row-layout justifyContent="center" [fullWidth]="true" gap="md">
        <button
          text-button
          size="md"
          variant="secondary"
          (click)="fileDropZone.openFileSelector()"
        >
          Browse Files
        </button>
        <button
          text-button
          size="md"
          variant="success"
          (click)="uploadFile()"
          [disabled]="!selectedFile() || !uploadForm.controls.entityCode.value"
        >
          Upload
        </button>
      </div>
    </app-card>
  </div>

  <div box-layout paddingVertical="md" [grow]="1">
    @if (buyerService.noBuyerImportHistory()) {
      <div center-layout [grow]="1" [fullWidth]="true">
        <Text role="title-large">No buyer import history.</Text>
      </div>
    }
    <app-log-table
      [datasource]="dataSyncHistoryDatasource"
      label="Upload History"
      [loading]="buyerService.buyerImportHistory.isLoading()"
      (reload)="buyerService.buyerImportHistory.reload()"
      [heightOffset]="670"
    />
  </div>
</app-page>

<app-validation-errors-dialog
  dialogTitle="Buyer Upload"
  [errors]="validationErrors()"
/>
